<template>
  <div class="flex-column gap-32" style="max-width: 352px;">
    <div class="flex-column align-items-center gap-24">
      <img src="/assets/img/fast-forward.png" width="74" height="74" />
      <div class="flex-column gap-16" style="font-size: 14px;">
        <h1 class="h bold" style="font-size: 24px; text-align: center;">
          {{ $t('bnpl:kyc.skip_popup.title') }}
        </h1>
        <div class="flex-column" style="color: var(--gray600);">
          <span style="margin-bottom: 1rem;">
            {{ $t('bnpl:kyc.skip_popup.description_1') }}
          </span>
          <p class="bold" style="margin-bottom: 1rem;">
            {{ $t('bnpl:kyc.skip_popup.description_2') }}
          </p>
          <ul class="pl-3">
            <li class="mb-1">
              {{ $t('bnpl:kyc.skip_popup.description_bullet_points_1') }}
              <span class="bold">
                {{ $t('bnpl:kyc.skip_popup.description_bullet_points_1.or') }}
              </span>
            </li>
            <li>
              {{ $t('bnpl:kyc.skip_popup.description_bullet_points_2') }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex-column gap-24">
      <div class="gray-box">
        <div class="flex-column gap-16">
          <p class="bold">
            {{ $t('bnpl:kyc.skip_popup.skip_tile.title') }}
          </p>
          <div class="flex-row gap-16">
            <IllustrationsFallbackContract width="76" height="56" style="flex-shrink: 0;" />
            <p>
              {{ $t('bnpl:kyc.skip_popup.skip_tile.description') }}
            </p>
          </div>
        </div>
        <button class="btn btnL" style="width: fit-content;" @click="$emit('skip')">
          {{ $t('bnpl:kyc.skip_popup.skip_tile.button') }}
          <i class="pi pi-arrow-right" />
        </button>
      </div>
      <div
        v-if="payInFullEnabled"
        class="gray-box gap-32"
      >
        <div class="flex-column gap-8">
          <p class="bold">
            {{ $t('bnpl:kyc.skip_popup.pay_now_tile.title') }}
          </p>
          <p>
            {{ $t('bnpl:kyc.skip_popup.pay_now_tile.description') }}
          </p>
        </div>
        <button class="btn btnM btn-neutral" style="width: fit-content;" @click="$emit('payNow')">
          {{ $t('bnpl:kyc.skip_popup.pay_now_tile.button', { fullAmount: $n(payInFullAmount, 'currency') }) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useBnplApplicationStore } from '~~/stores/bnplapplication';

const bnplApplicationStore = useBnplApplicationStore()

const payInFullEnabled = computed(() => bnplApplicationStore.payInFullEnabled)
const payInFullAmount = computed(() => bnplApplicationStore.payInFullAmount)
</script>

<style scoped>
.gray-box {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 24px;
  background: var(--gray50);
  padding: 20px;
  border-radius: 28px;
  font-size: 14px;
  color: var(--gray600);

  .bold {
    color: var(--gray600);
  }
}
</style>